export const Routes = {
  twoFa: '/authentication/twofa',
  Auth: '/authentication',
  Login: '/authentication/login',
  Signup: '/authentication/get-started',
  EmailExists: '/authentication/email-exists',
  EmailConfirmation: '/authentication/email-confirmation',
  ForgotPassword: '/authentication/forgot-password',
  ResetPassword: '/authentication/reset-password',
  InviteAccept: '/authentication/invitation/accept',
  InviteByLink: '/authentication/users/invitation',
  Errors: '/errors/404',

  CreateWorkspace: '/authentication/create',
  LaunchWorkspace: '/authentication/launch',

  Workspace: '/workspace',
  WorkspaceInformation: '/workspace/information',
  WorkspaceManagement: '/workspace/management',
  WorkspaceInvitation: '/workspace/invitation',
  WorkspaceComplete: '/workspace/complete',

  Logout: '/logout',
};
